export const LOGIN = "LOGIN";
export const REGISTER = "REGISTER";
export const ERRORS = "ERRORS";
export const LOGIN_ERRORS = "LOGIN_ERRORS";
export const USER = "USER";
export const UPDATE_USER = "UPDATE_USER";
export const CLEAR_USER = "CLEAR_USER";
